import {alpha} from '@mui/material/styles';
import {buttonBaseClasses} from '@mui/material/ButtonBase';
import {dividerClasses} from '@mui/material/Divider';
import {menuItemClasses} from '@mui/material/MenuItem';
import {tabClasses} from '@mui/material/Tab';
import {gray, brand} from '../themePrimitives';

export const navigationCustomizations = {
    MuiMenuItem: {
        styleOverrides: {
            root: ({theme}) => ({
                borderRadius: (theme.vars || theme).shape.borderRadius,
                padding: '6px 8px',
                [`&.${menuItemClasses.focusVisible}`]: {
                    backgroundColor: 'transparent'
                },
                [`&.${menuItemClasses.selected}`]: {
                    [`&.${menuItemClasses.focusVisible}`]: {
                        backgroundColor: alpha(theme.palette.action.selected, 0.3)
                    }
                }
            })
        }
    },
    MuiMenu: {
        styleOverrides: {
            list: ({theme}) => ({
                gap: '1px',
                // The list runs edge-to-edge horizontally (no left/right padding) so
                // ListSubheader bands can span the full menu width. Items instead
                // carry their own horizontal margin for the inset — this keeps the
                // inset symmetric and independent of the vertical scrollbar, which
                // otherwise ate the right inset on narrow/xs menus.
                paddingLeft: 0,
                paddingRight: 0,
                '& > .MuiMenuItem-root': {
                    marginLeft: 8,
                    marginRight: 8
                },
                // A leading section header sits flush with the top of the menu: pull
                // it up over the list's 8px top padding and round its top corners to
                // match the paper. Scoped to menus — the Autocomplete listbox has no
                // top padding, so it must not be pulled up (see below).
                '& > .MuiListSubheader-root:first-of-type': {
                    marginTop: -8,
                    borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                    borderTopRightRadius: (theme.vars || theme).shape.borderRadius
                },
                [`&.${dividerClasses.root}`]: {
                    margin: '0 -8px'
                }
            }),
            paper: ({theme}) => ({
                marginTop: '4px',
                paddingLeft: 0,
                paddingRight: 0,
                borderRadius: (theme.vars || theme).shape.borderRadius,
                border: `1px solid ${(theme.vars || theme).palette.divider}`,
                backgroundImage: 'none',
                background: 'hsl(0, 0%, 100%)',
                boxShadow: 'hsla(215, 30%, 8%, 0.07) 0px 4px 16px 0px, hsla(215, 25%, 12%, 0.08) 0px 8px 16px -5px',
                [`& .${buttonBaseClasses.root}`]: {
                    '&.Mui-selected': {
                        backgroundColor: alpha(theme.palette.action.selected, 0.3)
                    }
                }
            })
        }
    },
    MuiAutocomplete: {
        styleOverrides: {
            paper: ({theme}) => ({
                marginTop: '4px',
                borderRadius: (theme.vars || theme).shape.borderRadius,
                border: `1px solid ${(theme.vars || theme).palette.divider}`
                // background: 'hsl(0, 0%, 100%)',
                // background: 'transparent'
            }),
            listbox: ({theme}) => ({
                gap: '0px',
                padding: 0,
                // paddingLeft: '0px',
                // paddingRight: '6px',
                borderRadius: (theme.vars || theme).shape.borderRadius,
                backgroundImage: 'none',
                background: 'hsl(0, 0%, 100%)',
                boxShadow: 'hsla(215, 30%, 8%, 0.07) 0px 4px 16px 0px, hsla(215, 25%, 12%, 0.08) 0px 8px 16px -5px',
                '& .MuiAutocomplete-option': {
                    borderRadius: 4,
                    paddingLeft: 10,
                    paddingRight: 10,
                    margin: '0px 4px 4px 4px',
                    '&:first-of-type': {
                        marginTop: 4
                    }
                },
                [`& .${buttonBaseClasses.root}`]: {
                    '&.Mui-selected': {
                        backgroundColor: alpha(theme.palette.action.selected, 0.3),
                        borderRadius: (theme.vars || theme).shape.borderRadius
                    }
                },
                '& > li:first-of-type .MuiListSubheader-root': {
                    borderTop: 0
                },
                '& > li .MuiListSubheader-root': {
                    borderRadius: 0,
                    borderTop: `1px solid ${(theme.vars || theme).palette.divider}`
                }
            }),
            // The group label is a sticky ListSubheader. MUI's default sits it at
            // top: -8 to counteract the listbox's default 8px top padding — but we
            // zero that padding above, so -8 stuck the header 8px past the top edge
            // and clipped its top padding once scrolled. Pin it flush at top: 0.
            groupLabel: () => ({
                top: 0
            }),
            groupUl: () => ({
                marginTop: 1,
                marginBottom: 1,
                '& li': {
                    // borderRadius: (theme.vars || theme).shape.borderRadius
                }
            })
        }
    },
    MuiSelect: {
        // defaultProps: {
        //     IconComponent: forwardRef((props, ref) => (
        //         <UnfoldMoreRoundedIcon fontSize="small" {...props} ref={ref} />
        //     ))
        // },
        styleOverrides: {
            root: () => ({
                // borderRadius: (theme.vars || theme).shape.borderRadius,
                // border: '1px solid',
                // borderColor: gray[200],
                // backgroundColor: (theme.vars || theme).palette.background.paper,
                // boxShadow: `inset 0 1px 0 1px hsla(220, 0%, 100%, 0.6), inset 0 -1px 0 1px hsla(220, 35%, 90%, 0.5)`,
                // '&:hover': {
                //   borderColor: gray[300],
                //   backgroundColor: (theme.vars || theme).palette.background.paper,
                //   boxShadow: 'none',
                // },
                // [`&.${selectClasses.focused}`]: {
                //   outlineOffset: 0,
                //   borderColor: gray[400],
                // },
                // '&:before, &:after': {
                //   display: 'none',
                // }
            })
            // select: ({theme}) => ({
            //     display: 'flex',
            //     alignItems: 'center'
            // }),
            // menu: ({theme}) => ({
            //     marginTop: '4px',
            //     backgroundColor: 'red'
            // })
        }
    },
    MuiLink: {
        defaultProps: {
            underline: 'none'
        },
        styleOverrides: {
            root: ({theme}) => ({
                color: (theme.vars || theme).palette.text.primary,
                fontWeight: 500,
                position: 'relative',
                textDecoration: 'none',
                width: 'fit-content',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    width: '100%',
                    height: '1px',
                    bottom: 0,
                    left: 0,
                    backgroundColor: (theme.vars || theme).palette.text.secondary,
                    opacity: 0.3,
                    transition: 'width 0.3s ease, opacity 0.3s ease'
                },
                '&:hover::before': {
                    width: 0
                },
                '&:focus-visible': {
                    outline: `3px solid ${alpha(brand[500], 0.5)}`,
                    outlineOffset: '4px',
                    borderRadius: '2px'
                }
            })
        }
    },
    MuiDrawer: {
        styleOverrides: {
            paper: ({theme}) => ({
                backgroundColor: (theme.vars || theme).palette.background.default
            })
        }
    },
    MuiListItemButton: {
        styleOverrides: {
            root: ({theme}) => ({
                borderRadius: (theme.vars || theme).shape.borderRadius
            })
        }
    },
    MuiPaginationItem: {
        styleOverrides: {
            root: ({theme}) => ({
                '&.Mui-selected': {
                    color: '#fff',
                    backgroundColor: (theme.vars || theme).palette.grey[900]
                }
            })
        }
    },
    MuiTabs: {
        styleOverrides: {
            root: {minHeight: 'fit-content'},
            indicator: ({theme}) => ({
                backgroundColor: (theme.vars || theme).palette.grey[800]
            })
        }
    },
    MuiTabPanel: {
        styleOverrides: {
            root: {
                paddingLeft: 0,
                paddingRight: 0
            }
        }
    },
    MuiTab: {
        styleOverrides: {
            root: ({theme}) => ({
                padding: '12px 8px 12px 8px',
                // marginBottom: '8px',
                textTransform: 'none',
                minWidth: 'fit-content',
                minHeight: 'fit-content',
                color: (theme.vars || theme).palette.text.secondary,
                // borderRadius: (theme.vars || theme).shape.borderRadius,
                border: '1px solid',
                borderColor: 'transparent',
                borderTopLeftRadius: (theme.vars || theme).shape.borderRadius,
                borderTopRightRadius: (theme.vars || theme).shape.borderRadius,
                ':hover': {
                    color: (theme.vars || theme).palette.text.primary,
                    backgroundColor: gray[50]
                },
                [`&.${tabClasses.selected}`]: {
                    color: gray[900]
                }
            })
        }
    },
    MuiStepConnector: {
        styleOverrides: {
            line: ({theme}) => ({
                borderTop: '1px solid',
                borderColor: (theme.vars || theme).palette.divider,
                flex: 1,
                borderRadius: '99px'
            })
        }
    },
    MuiStepIcon: {
        styleOverrides: {
            root: ({theme}) => ({
                color: 'transparent',
                border: `1px solid ${gray[400]}`,
                width: 12,
                height: 12,
                borderRadius: '50%',
                '& text': {
                    display: 'none'
                },
                '&.Mui-active': {
                    border: 'none',
                    color: (theme.vars || theme).palette.primary.main
                },
                '&.Mui-completed': {
                    border: 'none',
                    color: (theme.vars || theme).palette.success.main
                },
                variants: [
                    {
                        props: {completed: true},
                        style: {
                            width: 12,
                            height: 12
                        }
                    }
                ]
            })
        }
    },
    MuiStepLabel: {
        styleOverrides: {
            label: () => ({
                '&.Mui-completed': {
                    opacity: 0.6
                }
            })
        }
    }
};
